<template>
    <!-- <component -->
    <!-- :is="form ? 'form' : 'div'" -->
    <!-- class="bg-white shadow border border-gray-300 mx-4 lg:mx-0 rounded-lg dark:bg-gray-900 dark:border-gray-900" -->
    <!-- @submit="submit" -->
    <!-- > -->
    <component
        :is="form ? 'form' : 'div'"
        :class="[
            'bg-white',
            'shadow',
            'border',
            'border-gray-300',
            'mx-0',
            // 'lg:mx-0',
            'rounded-lg',
            'dark:bg-gray-900',
            'dark:border-gray-900',
            customClass,
        ]"
        @submit="submit"
    >
        <header
            v-if="title"
            class="flex items-stretch border-b border-gray-200 dark:border-gray-700"
        >
            <p
                class="flex items-center py-3 flex-grow font-bold px-4"
            >
                <icon
                    v-if="icon"
                    :path="icon"
                    class="mr-3"
                />
                {{ title }}
                <br>
                {{ title2 }}
            </p>

            <a
                v-if="computedHeaderIcon"
                href="#"
                class="rounded-tr-lg flex items-center py-3 px-2 text-lg justify-center"
                aria-label="more options"
                @click.prevent="headerIconClick"
            >
                <icon
                    class="text-gray-500"
                    size="24"
                    :path="computedHeaderIcon"
                />
            </a>
        </header>
        <div
            v-if="empty"
            class="text-center py-24 text-gray-500 dark:text-gray-400"
        >
            <p>Nothing's here…</p>
        </div>
        <div
            v-else-if="data"
            :class="{'p-2':!hasTable}"
        >
            <slot />
        </div>
        <div
            v-else
            :class="{'p-4':!hasTable}"
        >
            <slot />
        </div>
        <footer
            v-if="month"
        >
            <slot name="footer" />
        </footer>
    </component>
</template>

<script>
import Icon from '@/components/Utilities/Icon'
import { computed } from 'vue'

export default {
    name: 'CardComponent',
    components: { Icon },
    props: {
        title: String,
        title2: String,
        icon: String,
        headerIcon: String,
        hasTable: Boolean,
        empty: Boolean,
        form: Boolean,
        rounded: {
            type: String,
            default: 'md:rounded'
        },
        customClass: String,
        month: String,
        data: Boolean,
    },
    emits: ['header-icon-click', 'submit'],
    setup (props, { emit }) {
        const computedHeaderIcon = computed(() => props.headerIcon ?? false) // mdiCog

        const headerIconClick = () => {
            emit('header-icon-click')
        }

        const submit = e => {
            emit('submit', e)
        }

        return {
            computedHeaderIcon,
            headerIconClick,
            submit
        }
    }
}
</script>
